export default "__VITE_PUBLIC_ASSET__5671f84d__"